import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonTranslateModule } from "@shared/utils/common-translate.module";
import { SearchRiskTagsComponent } from "./search-risk-tags.component";

@NgModule({
  declarations: [SearchRiskTagsComponent],
  imports: [CommonModule, CommonTranslateModule, FormsModule, ReactiveFormsModule],
  exports: [SearchRiskTagsComponent],
})
export class SearchRiskTagsModule {}
